import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxPermissionsModule } from "ngx-permissions";
import { MaterialModule } from "../../../components/material/material.module";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { CrearTipoPagoComponent } from "./crear-tipo-pago/crear-tipo-pago.component";
import { CrearTipoPagoDialog } from "./crear-tipo-pago/crear-tipo-pago-dialog/crear-tipo-pago-dialog.component";
import { EditarTipoPagoComponent } from "./editar-tipo-pago/editar-tipo-pago.component";
import { EditarTipoPagoDialog } from "./editar-tipo-pago/editar-tipo-pago-dialog/editar-tipo-pago-dialog.component";
import { EliminarTipoPagoComponent } from "./eliminar-tipo-pago/eliminar-tipo-pago.component";
import { EliminarTipoPagoDialog } from "./eliminar-tipo-pago/eliminar-tipo-pago-dialog/eliminar-tipo-pago-dialog.component";
import { IrTipoPagoComponent } from "./ir-tipo-pago/ir-tipo-pago.component";
import { TipoPagoComponent } from "./tipo-pago/tipo-pago.component";
import { VerTiposPagoComponent } from "./ver-tipos-pago/ver-tipos-pago.component";
import { RouterModule } from "@angular/router";
import { TipoPagoService } from "../../../providers/tipo-pago.service";

@NgModule({
    imports: [
        CommonModule,
        NgxPermissionsModule.forChild(),
        MaterialModule,
        ReactiveFormsModule,
        FormsModule,
        RouterModule,
    ],
    declarations: [
        CrearTipoPagoComponent,
        CrearTipoPagoDialog,
        EditarTipoPagoComponent,
        EditarTipoPagoDialog,
        EliminarTipoPagoComponent,
        EliminarTipoPagoDialog,
        IrTipoPagoComponent,
        TipoPagoComponent,
        VerTiposPagoComponent,
    ],
    entryComponents: [
        CrearTipoPagoDialog,
        EditarTipoPagoDialog,
        EliminarTipoPagoDialog,
    ],
    exports: [
        CrearTipoPagoComponent,
        EditarTipoPagoComponent,
        EliminarTipoPagoComponent,
        IrTipoPagoComponent,
        TipoPagoComponent,
        VerTiposPagoComponent,
    ],
    providers: [
        TipoPagoService
    ]
})
export class TipoPagoModule { }